import { FormField } from '~/utils/form';
import { ConsultclientCancelResponse } from '~/services/consult/user/detail/response';
import IResponseGetUserDocuments from '~/services/files/getUserDocuments/response';

export const isCartaoBloqueado = (status: string) => {
  return [
    'CANCELAMENTO_EXPERIENCIA',
    'CANCELAMENTO_SOLICITACAO',
    'CANCELAMENTO_INATIVIDADE',
    'CANCELAMENTO_PROPOSTA',
  ].includes(status);
};

export interface Form {
  id?: FormField;
  celular?: FormField;
  celular2?: FormField;
  dataNascimento?: FormField;
  email?: FormField;
  genero?: FormField;
  idClienteAutorizador?: FormField;
  idUsuario?: FormField;
  dataCadastro?: FormField;
  nome?: FormField;
  nomeSocial?: FormField;
  endBairro?: FormField;
  endCep?: FormField;
  endCidade?: FormField;
  endComplemento?: FormField;
  endLogradouro?: FormField;
  endNumero?: FormField;
  endPais?: FormField;
  endUf?: FormField;
  cardAnoExpiracao?: FormField;
  cardBandeira?: FormField;
  cardBloqueado?: FormField;
  cardImpresso?: FormField;
  cardLimiteCredito?: FormField;
  cardMesExpiracao?: FormField;
  aposentadoPensionista?: boolean;
  cardNomeTitular?: FormField;
  cardNumeroCartao?: FormField;
  dataAtivacao?: FormField;
  cardStatus?: FormField;
  checkWhatsapp?: boolean;
  optinTermoDeUso?: boolean;
  origemOptin?: FormField;
  diaVencimento: FormField;
  melhorDiaCompra: FormField;
  profissao: FormField;
  nomeEmpresa: FormField;
  rendaInformada: FormField;
  dataEmissao: FormField;
  dataImpressao: FormField;
  dataAprovacao: FormField;
  dataCorte: FormField;
  saldo: FormField;
  temaCartao: FormField;
  lojaNome: FormField;
  emCobranca: FormField;
  propDataCadastro: FormField;
  propDigitador: FormField;
  propLojaDoCadastro: FormField;
  propOrigemDoCadastro: FormField;
  propNomeOperador: FormField;
  propStatusAprovacao: FormField;
  propStatus: FormField;
  dataCancelamento: FormField;
  statusCliente: FormField;
  readmissao: boolean;
  limiteSaque: FormField;
  tipoCanc: string;
  temCartaoCredito: boolean;
  temCarteiraDigital: boolean;
  temEmprestimo: boolean;
  nivel: string;
  quantidadeTotalPaga: number;
  quantidadeTotalParcial: number;
  quantidadeTotalParcelada: number;
  quantidadeCobranca: number;
  dataDecisao: FormField;
  pontuacao: number;
  dataCampanha: string;
  categoriaCartao: FormField;
  carteira?: {
    cartoes: [
      {
        bandeira: string;
        blackList: boolean;
        numeroCartao: string;
        principal: boolean;
        validado: boolean;
        id: string;
      },
    ];
    dataAdesao: string;
    dataPrimeiraCompra: string;
    nomeOperador: string;
  };
  tipoDoc: string;
}

export interface ProductsProps {
  filter: any;
  descricao: string;
  imagem: string;
  mensagem: string;
  nome: string;
  tipoProduto: string;
  status?: string;
}

export interface LocationState {
  cpf: string;
  numeroCartao: string;
  produtos: ProductsProps[];
}

export interface IDocumentsImage {
  income: {
    front: string;
    tipo?: string;
    nome?: string;
  };
  address: {
    front: string;
    tipo?: string;
    nome?: string;
  };
}

export interface ICardDeliveryTermImage {
  term: {
    front: string;
    tipo?: string;
  };
}

export interface IThemeCard {
  categoria: string;
  descricao?: string;
  descricaoTema: string;
  idExterno: string;
  link: string;
  modeloTema: string;
  urlImagem: string;
  valor: Number;
}

export interface ISearchOCRProposal {
  campos: {
    title: string;
    value: string;
  }[];
}

export type CancelInvoiceItem = ConsultclientCancelResponse['faturas'][number];

export type UserDocumentsResponse = IResponseGetUserDocuments & {
  documentoLimiteCredito?: string;
};
